/**
 * Blog posts slider for the "Custom Blog Posts" section.
 *
 * Uses the theme's Swiper 5 build (window.ThemeSwiper, set in the layout right after
 * swiper.min.js), because app embeds may overwrite window.Swiper with a newer version.
 */
// Block-scoped so the file can be included once per section instance without redeclaring the class
if (!customElements.get("custom-blog-slider")) {
  class CustomBlogSlider extends HTMLElement {
    static breakpoints = {
      750: { slidesPerView: 2.1 },
      1024: { slidesPerView: 3 },
    };

    connectedCallback() {
      const SwiperLib = window.ThemeSwiper || window.Swiper;
      const container = this.querySelector(".swiper-container");
      if (!SwiperLib || !container || this.swiper) return;

      this.swiper = new SwiperLib(container, {
        direction: "horizontal",
        loop: this.canLoop(container),
        speed: 500,
        autoHeight: true,
        // Images are lazy loaded natively; preloading would fetch them all on init
        preloadImages: false,
        slidesPerView: 1.1,
        breakpoints: CustomBlogSlider.breakpoints,
      });
    }

    disconnectedCallback() {
      if (!this.swiper) return;
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    /**
     * Loop mode needs more slides than are visible at once on the widest breakpoint,
     * otherwise Swiper warns and disables it.
     * @param {HTMLElement} container
     * @returns {boolean}
     */
    canLoop(container) {
      const slideCount = container.querySelectorAll(".swiper-slide").length;
      const maxSlidesPerView = Math.max(
        ...Object.values(CustomBlogSlider.breakpoints).map((bp) => bp.slidesPerView),
      );
      return slideCount >= Math.ceil(maxSlidesPerView) + 1;
    }
  }

  customElements.define("custom-blog-slider", CustomBlogSlider);
}
